// Grids & Gantts — a field NAME, resolved against this site.
//
// A structure's config names fields the way a person does ("Start date",
// "Client Name"), never by id: the name survives a site rebuild, the id
// does not. These resolve a name against /api/fields at load time.

export const normName = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// "Project" / "Status" / "Work type" / "Summary" / "Due date" / "Created"
// are the built-ins; anything else is looked up by name.
export const BUILT_IN = {
  project: 'project', status: 'status', worktype: 'issuetype', issuetype: 'issuetype',
  summary: 'summary', duedate: 'duedate', due: 'duedate', created: 'created', key: 'key',
};

export function resolveField(want, fieldList) {
  if (!want) return null;
  const w = String(want).trim();
  if (/^customfield_\d+$/.test(w)) return w;
  const b = BUILT_IN[normName(w)];
  if (b) return b;
  const target = normName(w);
  const hit = (Array.isArray(fieldList) ? fieldList : []).find((f) => f && (normName(f.name) === target || f.id === w || f.key === w));
  return hit ? (hit.id || hit.key) : null;
}

export function fieldLabel(want, fieldList) {
  if (!want) return '';
  const id = resolveField(want, fieldList);
  const hit = (Array.isArray(fieldList) ? fieldList : []).find((f) => f && (f.id === id || f.key === id));
  return (hit && hit.name) || want;
}
